var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "draggable",
        {
          attrs: {
            list: _vm.activeData,
            animation: 340,
            group: "selectItem",
            handle: ".option-drag",
          },
          on: { update: _vm.add1 },
        },
        _vm._l(_vm.activeData, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "select-item mb5" },
            [
              _c("div", { staticClass: "select-line-icon option-drag mr5" }, [
                _c("i", { staticClass: "iconfont icontuodong" }),
              ]),
              _vm._v(" "),
              _c("el-input", {
                staticClass: "mr5",
                attrs: { placeholder: "请输入内容" },
                on: {
                  input: function ($event) {
                    return _vm.setOptionValue(item, $event)
                  },
                },
                model: {
                  value: item.label,
                  callback: function ($$v) {
                    _vm.$set(item, "label", $$v)
                  },
                  expression: "item.label",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "close-btn select-line-icon",
                  on: {
                    click: function ($event) {
                      return _vm.activeData.splice(index, 1)
                    },
                  },
                },
                [_c("i", { staticClass: "el-icon-remove-outline" })]
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-left": "20px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "padding-bottom": "0" },
              attrs: { icon: "el-icon-circle-plus-outline", type: "text" },
              on: { click: _vm.addSelectItem },
            },
            [_vm._v("添加选项")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }